function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m145.77 290.2c-6.137 0-12.25-5.831-13.412-7.002-4.194-3.092-115.08-86.691-127.27-98.856-4.422-4.444-5.203-8.894-5.074-11.856 0.288-7.089 5.768-11.935 6.389-12.463l123.34-102.07c1.351-1.474 7.617-7.611 13.577-7.611 2.717 0 9.031 1.243 9.031 12.691v52.623h174.12c0.486-0.081 1.135-0.156 1.903-0.156 2.03 0 12.16 0.774 12.16 15.976v80.87c0 11.187-7.927 14.153-12.118 14.153h-172.4v48.23c0 13.469-6.419 15.475-10.244 15.475zm0-9.746v4.87-4.87z"
});

var SvgLeftArrow = function SvgLeftArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    width: "100px",
    height: "auto",
    viewBox: "0 0 340.533 340.533",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeftArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/left-arrow.2ee58472.svg";
export { ForwardRef as ReactComponent };